// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_fs-1";
export var quotedThread = "_fs-0";